import { render, staticRenderFns } from "./MyWish.vue?vue&type=template&id=49f0dca8&scoped=true&"
import script from "./MyWish.vue?vue&type=script&lang=js&"
export * from "./MyWish.vue?vue&type=script&lang=js&"
import style0 from "./MyWish.vue?vue&type=style&index=0&id=49f0dca8&scoped=true&lang=css&"
import style1 from "./MyWish.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f0dca8",
  null
  
)

export default component.exports